export const GA_REPORT_EVENT_CATEGORY = 'ReportThisEvent';

export const GA_ACTION_LANDING_SHOWN = 'LandingShown';
export const GA_ACTION_FORM_SHOWN = 'FormShown';
export const GA_ACTION_REASON_SELECTED = 'ReasonSelected';
export const GA_ACTION_FORM_CONFIRMATION_SHOWN = 'FormConfirmationShown';
export const GA_ACTION_FORM_SUBMITTED = 'FormSubmitted';
export const GA_ACTION_FORM_SUBMISSION_ERROR = 'FormSubmissionError';
export const GA_ACTION_FORM_DISMISSED = 'FormDismissed';

export const LANDING_VIEW = 'LandingView';
export const FORM_VIEW = 'FormView';
export const FORM_CONFIRMATION_VIEW = 'FormConfirmationView';
export const SUCCESS_VIEW = 'SuccessView';

export const INPUT_REPORT_EMAIL_LABEL = 'Your Email';
export const INPUT_REPORT_EMAIL_PLACEHOLDER = 'name@example.com';
export const INPUT_REPORT_DESCRIPTION_LABEL = 'Description';
export const INPUT_REPORT_DESCRIPTION_PLACEHOLDER =
    'Additional details are required for all reported issues.';

export const REPORT_HELPER_TEXT: { [key: string]: string } = {
    reason_unauthorized_event:
        'This event is a copy of another event, is reselling tickets, or the tickets I purchased were not valid for entry. Include the URL for the authorized event and your relationship to the event.',
    reason_harmful: 'Ex: bullying, harmful misinformation',
    reason_offensive_content: 'Ex: drugs, gambling',
    reason_explicit: 'Ex: graphic nudity, pornography',
    reason_hateful: 'Ex: threats or intimidation of a protected group',
    reason_extremism: 'Ex: graphic violence, dangerous organizations',
    reason_canceled_event:
        'The event was canceled, postponed, rescheduled, or did not deliver the advertised experience. Include details about how you were informed of any changes and how the event was different than what was advertised.',
    report_default: INPUT_REPORT_DESCRIPTION_PLACEHOLDER,
    reason_spam_behavior:
        "The listing is not advertising an event (ex: it promotes a product or service, or it's unclear what is being advertised), is listed repeatedly and is interfering with search results, or it includes deceptive or exaggerated claims about the success of using the advertised services.",
    reason_payment_outside:
        'This event asks for payment at the door or an alternate payment platform such as PayPal, CashApp, or Venmo.',
};

export const skipFeedbackReasons = [
    'reason_unauthorized_event',
    'reason_payment_outside',
];
